var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 121,
    viewBox: "0 0 169 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168.661,
    height: 120.472,
    rx: 12.047,
    fill: "#0742A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.16 76.484h-8.53l5.335-32.123h8.528L77.16 76.484zM108.073 45.147c-1.682-.65-4.35-1.368-7.65-1.368-8.422 0-14.353 4.374-14.39 10.628-.07 4.614 4.247 7.176 7.475 8.715 3.3 1.572 4.422 2.597 4.422 3.999-.034 2.152-2.667 3.144-5.122 3.144-3.405 0-5.23-.512-8.002-1.709l-1.123-.513-1.194 7.21c2 .888 5.686 1.676 9.512 1.71 8.949 0 14.775-4.306 14.844-10.97.034-3.657-2.245-6.459-7.159-8.748-2.983-1.47-4.81-2.461-4.81-3.965.035-1.367 1.545-2.768 4.913-2.768 2.772-.068 4.809.58 6.353 1.23l.771.342 1.16-6.937zM123.34 44.361h6.597l6.88 32.123h-7.897s-.772-3.691-1.017-4.819h-10.95l-1.79 4.819h-8.949l12.668-29.457c.878-2.085 2.423-2.666 4.458-2.666zm-.527 11.755s-2.702 7.143-3.405 8.988h7.089c-.35-1.606-1.965-9.295-1.965-9.295l-.597-2.768c-.251.713-.613 1.693-.858 2.354-.166.447-.278.749-.264.721zM61.505 44.361l-8.353 21.905-.912-4.442c-1.544-5.127-6.387-10.696-11.792-13.465l7.65 28.091h9.02l13.405-32.089h-9.018z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.398 44.361H31.676l-.14.65C42.24 47.675 49.33 54.1 52.242 61.824l-2.983-14.763c-.492-2.052-2-2.633-3.86-2.7z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.394b81ef9a783b3992f79a6f9fb1507c.svg";
export { ForwardRef as ReactComponent };